import React from "react";
import { COMPLAINTS_POINT_RADIUS } from "@shared/config";

type ComplaintsAreaProps = {
  cx: number;
  cy: number;
  onClick: () => void;
};

export const ComplaintsArea: React.FC<ComplaintsAreaProps> = ({
  cx,
  cy,
  onClick,
}) => {
  return (
    <g className="cursor-pointer" onClick={onClick}>
      <circle
        cx={cx}
        cy={cy}
        r={COMPLAINTS_POINT_RADIUS}
        fill={"url(#grad)"}
        className="hover:fill-[url(#grad-hover)]"
      />
    </g>
  );
};

export default ComplaintsArea;
